// Static data used across pages
export const LOGO_MARK = "https://customer-assets.emergentagent.com/job_ai-career-hub-33/artifacts/ba6dbd6b_xyro-mark.png.asset.json.PNG";
export const LOGO_LOCKUP = "https://customer-assets.emergentagent.com/job_ai-career-hub-33/artifacts/9sjf6clg_xyro-lockup.png.asset.json.PNG";

export const WHATSAPP_NUMBER = "917874867455";
export const WHATSAPP_DISPLAY = "+91 78748 67455";
export const CONTACT_EMAIL = "akash@xyrotechsolution.com";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  "Hi Xyro Tech, I'd like a free career consultation."
)}`;

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
  { label: "Success Stories", to: "/success-stories" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export const TRUST_COMPANIES = [
  "Google", "Microsoft", "Amazon", "Meta", "Oracle",
  "Deloitte", "Accenture", "Infosys", "TCS", "Cognizant",
];

export const PROBLEMS = [
  "Resume Rejections",
  "No Interview Calls",
  "LinkedIn Not Getting Views",
  "Job Search Confusion",
  "OPT / CPT Challenges",
  "H1B Career Planning",
];

export const SOLUTIONS = [
  "AI Resume Optimization",
  "LinkedIn Branding",
  "Interview Preparation",
  "Placement Support",
  "Career Mentorship",
  "Job Search Strategy",
];

export const AI_ENGINE = [
  {
    title: "AI Resume Analyzer",
    desc: "Instantly identify weaknesses and improve ATS score across 90+ data points.",
    icon: "FileSearch",
  },
  {
    title: "AI LinkedIn Optimizer",
    desc: "Improve visibility, headline strength and recruiter discovery rate.",
    icon: "Linkedin",
  },
  {
    title: "AI Job Match Finder",
    desc: "Find US roles that match your skills, visa and salary expectations.",
    icon: "Target",
  },
  {
    title: "AI Interview Coach",
    desc: "Practice behavioral, technical and case interviews with AI scoring.",
    icon: "MessagesSquare",
  },
  {
    title: "AI Career Roadmap",
    desc: "Personalized 30-60-90 day path to your dream US role.",
    icon: "Map",
  },
];

export const SERVICES = [
  { title: "Career Consultation", icon: "Compass", desc: "1:1 strategy session with US career experts." },
  { title: "Resume Building", icon: "FileText", desc: "ATS-optimized, recruiter-ready US resume." },
  { title: "LinkedIn Optimization", icon: "Linkedin", desc: "Headline, summary, keywords, banner & SEO." },
  { title: "Mock Interviews", icon: "Mic", desc: "Live mocks with feedback from industry experts." },
  { title: "Job Search Strategy", icon: "Search", desc: "Targeted outreach, referrals and pipelines." },
  { title: "Placement Assistance", icon: "Briefcase", desc: "Hands-on placement until you sign an offer." },
  { title: "Career Mentorship", icon: "Users", desc: "Ongoing 1:1 mentorship from senior leaders." },
  { title: "Networking Guidance", icon: "Share2", desc: "Tactical networking scripts and warm intros." },
  { title: "OPT / CPT Support", icon: "ShieldCheck", desc: "Compliance, employer search & documentation." },
  { title: "H1B Career Guidance", icon: "Plane", desc: "H1B-friendly companies and lottery strategy." },
  { title: "AI Career Assessment", icon: "Brain", desc: "Strengths, gaps and best-fit US career paths." },
  { title: "Personal Branding", icon: "Sparkles", desc: "Resume + LinkedIn + portfolio brand system." },
];

export const HOT_ROLES = [
  { role: "AI Engineer", salary: "$140k – $210k", demand: "Very High" },
  { role: "Machine Learning Engineer", salary: "$135k – $200k", demand: "Very High" },
  { role: "Data Scientist", salary: "$115k – $175k", demand: "High" },
  { role: "Data Analyst", salary: "$80k – $120k", demand: "High" },
  { role: "Business Analyst", salary: "$85k – $125k", demand: "High" },
  { role: "Cloud Engineer", salary: "$110k – $170k", demand: "High" },
  { role: "DevOps Engineer", salary: "$120k – $180k", demand: "High" },
  { role: "Software Engineer", salary: "$110k – $185k", demand: "Very High" },
  { role: "Cyber Security Analyst", salary: "$95k – $150k", demand: "High" },
  { role: "Full Stack Developer", salary: "$100k – $165k", demand: "High" },
  { role: "Python Developer", salary: "$95k – $155k", demand: "High" },
  { role: "Generative AI Engineer", salary: "$150k – $230k", demand: "Explosive" },
];

export const ROADMAP = [
  { step: 1, title: "Free Consultation", desc: "30-min discovery call with a US career strategist." },
  { step: 2, title: "Career Assessment", desc: "AI + human evaluation of your profile and goals." },
  { step: 3, title: "Resume Optimization", desc: "ATS-friendly, recruiter-ready US resume rewrite." },
  { step: 4, title: "LinkedIn Enhancement", desc: "SEO-tuned headline, summary, keywords & banner." },
  { step: 5, title: "Interview Preparation", desc: "Behavioral, technical and case interview drills." },
  { step: 6, title: "Job Search Strategy", desc: "Targeted outreach, referrals and recruiter pipelines." },
  { step: 7, title: "Placement Support", desc: "Daily applications, follow-ups and pipeline tracking." },
  { step: 8, title: "Offer Negotiation", desc: "Maximize base, bonus, equity and relocation." },
  { step: 9, title: "Career Growth Support", desc: "Promotion strategy and long-term US career growth." },
];

export const TESTIMONIALS = [
  {
    name: "Dev Patel",
    role: "Data Scientist",
    company: "US FinTech Company",
    package: "$120,000",
    before: "0 callbacks",
    interviews: "7 interviews",
    weeks: "5 weeks",
    above: "+22%",
    review:
      "Xyro transformed my resume and interview strategy. Within weeks I started receiving interview calls and landed my dream Data Scientist role.",
  },
  {
    name: "Ramani Iyer",
    role: "Machine Learning Engineer",
    company: "Healthcare AI Company",
    package: "$135,000",
    before: "2 callbacks",
    interviews: "11 interviews",
    weeks: "7 weeks",
    above: "+38%",
    review:
      "The AI-driven guidance and mentorship helped me stand out in a competitive US market full of strong candidates.",
  },
  {
    name: "Krishna Bharat",
    role: "Cloud Engineer",
    company: "Enterprise Technology Company",
    package: "$110,000",
    before: "1 callback",
    interviews: "5 interviews",
    weeks: "4 weeks",
    above: "+18%",
    review:
      "Their placement support and interview preparation were game changers. I had multiple offers within a month.",
  },
  {
    name: "Sunita Das",
    role: "Business Intelligence Analyst",
    company: "Analytics Company",
    package: "$95,000",
    before: "0 callbacks",
    interviews: "4 interviews",
    weeks: "6 weeks",
    above: "+12%",
    review:
      "From resume optimization to job placement, the entire process was seamless and incredibly professional.",
  },
  {
    name: "Shreya Trivedi",
    role: "Data Analyst",
    company: "Technology Startup",
    package: "$90,000",
    before: "3 callbacks",
    interviews: "9 interviews",
    weeks: "8 weeks",
    above: "+15%",
    review:
      "The team genuinely cared about my success and guided me every step of the way. Highly recommended.",
  },
];

export const FAQS = [
  { q: "What is Xyro Tech Solutions?", a: "Xyro Tech Solutions is an AI-powered US career acceleration partner that helps international students, OPT/CPT candidates, H1B professionals and experienced IT professionals get placed in high-paying US roles." },
  { q: "Who can use Xyro's services?", a: "International students, OPT/CPT candidates, H1B professionals, fresh graduates, and experienced IT professionals targeting roles in the United States." },
  { q: "Do you provide placement support for OPT candidates?", a: "Yes. Our OPT support covers employer search, compliance, resume positioning, interview preparation and end-to-end placement assistance." },
  { q: "How does Xyro support CPT candidates?", a: "We help CPT candidates find compliant employer matches, prepare for interviews and align coursework with real US job opportunities." },
  { q: "Can Xyro help me with H1B career planning?", a: "Absolutely. We focus on H1B-friendly companies, lottery strategy, timing and long-term US career growth." },
  { q: "How does the AI Resume Analyzer work?", a: "Our AI scans your resume against US ATS systems and recruiter heuristics across 90+ data points and recommends specific edits to improve interview callback rates." },
  { q: "What is LinkedIn Optimization?", a: "We rebuild your LinkedIn headline, summary, experience and keywords so recruiters in the US find you faster and your profile views increase significantly." },
  { q: "How long does it take to get placed?", a: "Most committed candidates start receiving interview calls within 2 – 6 weeks. Final placement timelines depend on your role, market conditions and visa status." },
  { q: "Is the consultation really free?", a: "Yes. The first 30-minute career consultation is completely free with no obligation." },
  { q: "What kinds of roles do you place candidates in?", a: "AI Engineer, ML Engineer, Data Scientist, Data Analyst, Business Analyst, Cloud Engineer, DevOps, Software Engineer, Cyber Security, Full Stack, Python Developer, Generative AI Engineer and more." },
  { q: "Do you guarantee a job?", a: "We do not promise unrealistic guarantees. We commit to world-class preparation, daily placement effort and complete strategic support until you sign an offer." },
  { q: "How are mock interviews conducted?", a: "Live 1:1 mocks with industry experts plus unlimited AI interview practice with instant scoring and feedback." },
  { q: "What companies have your candidates joined?", a: "Our students have been placed at companies like Google, Microsoft, Amazon, Meta, Oracle, Deloitte, Accenture, Infosys, TCS, Cognizant and many leading US startups." },
  { q: "Do I need prior US experience?", a: "No. We have helped fresh graduates, international students and career switchers successfully transition into high-paying US roles." },
  { q: "How is Xyro different from a training institute?", a: "We are not a training institute. We are an AI-powered career acceleration and placement partner focused on outcomes, not classroom hours." },
  { q: "Will you help me with offer negotiation?", a: "Yes. We help you negotiate base, bonus, equity, sign-on and relocation to maximize your final compensation." },
  { q: "Do you offer ongoing mentorship after placement?", a: "Yes. We provide career growth support, promotion planning and long-term mentorship after you are placed." },
  { q: "How do I get started?", a: "Book a free 30-minute career consultation through the form on this site or chat with us on WhatsApp for the fastest response." },
  { q: "Is my data safe with Xyro?", a: "Yes. We treat candidate information with strict confidentiality and only use it for your career acceleration journey." },
  { q: "How can I contact Xyro Tech Solutions?", a: "Email akash@xyrotechsolution.com or WhatsApp +91 78748 67455 for the fastest response." },
];

export const STATUS_OPTIONS = ["Student", "OPT", "CPT", "H1B", "Experienced", "Fresh Graduate"];
